import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";

const DropdownMenuIfCards = ({ lang, translations }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = (e) => {
    if (!e.target.closest(".menu-container")) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeMenu);
    return () => {
      document.removeEventListener("click", closeMenu);
    };
  }, []);

  // Función para manejar la navegación y el desplazamiento
  const handleNavigateAndScroll = (sectionId) => {
    const isHomePage = window.location.pathname === "/";
    if (!isHomePage) {
      navigate("/", { replace: true });
    }
    setTimeout(() => {
      scroller.scrollTo(sectionId, {
        duration: 800,
        smooth: "easeInOutQuart",
        offset: -70,
      });
    }, 100); // Ajusta el delay si es necesario
    setIsOpen(false);
  };

  return (
    <div className="menu-container" style={{ position: "relative", display: "inline-block" }}>
      {/* Botón del menú */}
      <button
        className="menu-button"
        onClick={toggleMenu}
        style={{
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className={`hamburger-icon ${isOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Menú desplegable */}
      {isOpen && (
        <div className="dropdown-menu">
          <div
            className="dropdown-options"
            onClick={() => handleNavigateAndScroll("aboutus")}
          >
            {translations[lang].gastronomytitle}
          </div>
          <div
            className="dropdown-options"
            onClick={() => handleNavigateAndScroll("card")}
          >
            {translations[lang].cardtitle}
          </div>
          <div
            className="dropdown-options"
            onClick={() => handleNavigateAndScroll("contact")}
          >
            {translations[lang].contacttitle}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenuIfCards;
